(() => {
  if (globalThis.RicochetExactSearch) return;
  const config = document.querySelector('[data-discovery-analytics]');
  // Explicit QA only: fixed state codes, never wording or visitor identifiers.
  const diagnostic = (status) => {
    if (new URLSearchParams(location.search).get('discovery_verify') === '1') {
      config?.setAttribute('data-exact-status', status);
      if (status === 'delivered' || status === 'transport-failed' || /^http-\d{3}$/.test(status))
        config?.setAttribute('data-exact-delivery', status);
    }
  };
  // Reopen Shopify's existing consent UI; never set consent on the visitor's behalf.
  const policyLink = document.querySelector('footer a[href="/policies/privacy-policy"]');
  if (policyLink?.closest('li') && !document.querySelector('[data-ricochet-privacy-choices]')) {
    const item = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.ricochetPrivacyChoices = '';
    button.textContent = 'Cookie preferences';
    button.style.cssText = 'border:0;padding:0;background:none;color:inherit;font:inherit;text-align:inherit;cursor:pointer;text-decoration:underline';
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        if (typeof globalThis.privacyBanner?.showPreferences !== 'function') throw new Error();
        await globalThis.privacyBanner.showPreferences();
        button.textContent = 'Cookie preferences';
      } catch { button.textContent = 'Preferences unavailable — please try again'; }
      finally { button.disabled = false; }
    });
    item.append(button);
    policyLink.closest('li').after(item);
  }
  let transportFailed = false;
  const enabled = () => !transportFailed && config?.dataset.exactEnabled === 'true' && config?.dataset.enabled === 'true'
    && globalThis.Shopify?.theme?.role === 'main' && !globalThis.Shopify?.designMode
    && config?.dataset.designMode !== 'true' && location.origin === 'https://ricochetoffroad.com'
    && !new URLSearchParams(location.search).has('preview_theme_id');
  const consent = () => { try {
    const privacy = globalThis.Shopify?.customerPrivacy;
    diagnostic(!privacy ? 'privacy-unavailable' : privacy.currentVisitorConsent()?.analytics !== 'yes'
      ? 'explicit-consent-required' : privacy.analyticsProcessingAllowed() !== true
        ? 'analytics-denied' : privacy.saleOfDataAllowed() !== true ? 'sale-opt-out' : 'consent-allowed');
    return privacy?.analyticsProcessingAllowed() === true
      && privacy.currentVisitorConsent()?.analytics === 'yes'
      && privacy.saleOfDataAllowed() === true;
  } catch { return false; } };
  const endpoint = () => {
    try {
      const url = new URL(config?.dataset.exactEndpoint || '');
      return url.protocol === 'https:' && !url.username && !url.password && !url.search && !url.hash
        && url.pathname === '/v1/exact-search' ? url.href : '';
    } catch { return ''; }
  };
  // Conservative heuristic, not a guarantee of anonymous text. Never log rejected text.
  const screen = (value) => {
    if (typeof value !== 'string' || !value.trim() || value.length > 100) return null;
    if (/\b(?:\d{1,3}\.){3}\d{1,3}\b|\b(?:[a-f0-9]{2}:){5}[a-f0-9]{2}\b|\b[a-f0-9]{8}-(?:[a-f0-9]{4}-){3}[a-f0-9]{12}\b/i.test(value)) return null;
    if (/[@\\\n\r\x00-\x1f]|\b[a-z][a-z0-9+.-]*:\/\/|www\.|\b(?:[a-z0-9-]+\.)+[a-z]{2,}\b|\b(?:https?|email|phone|tel|address|ssn|passport|account|order|vin)\b/i.test(value)) return null;
    if (/\d{7,}|\+\d|\(\d{3}\)|\b\d{3}[ .-]\d{3}[ .-]\d{4}\b|\b\d{3}-\d{2}-\d{4}\b|[a-z0-9]{17,}|\b[a-z0-9.-]+\.(?:com|net|org|io|co|gov|edu)\b|\b\d{1,6}\s+(?:[a-z]+\s+){0,3}(?:street|st|road|rd|avenue|ave|drive|dr|lane|ln|court|ct|way|boulevard|blvd)\b|\b(?:apt|suite|po box)\b/i.test(value)) return null;
    return value;
  };
  const states = new Map();
  const pending = [];
  let sending = false, controller;
  const clearTransport = () => { pending.length = 0; controller?.abort(); };
  const drain = async () => {
    if (sending) return;
    sending = true;
    try {
      while (pending.length && enabled() && consent() && endpoint()) {
        const item = pending.shift();
        if (Date.now() - item.at > 5000) continue;
        controller = new AbortController();
        const timer = setTimeout(() => controller?.abort(), 5000);
        try {
          const response = await fetch(endpoint(), { method: 'POST', credentials: 'omit',
            referrerPolicy: 'no-referrer', cache: 'no-store', redirect: 'error',
            headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
            body: JSON.stringify({name: item.name, payload: item.payload, consent: true, sale_allowed: true}) });
          diagnostic(response.status === 204 ? 'delivered' : `http-${response.status}`);
          if (response.status !== 204) { transportFailed = true; clearTransport(); break; }
        } catch { if (consent()) transportFailed = true; diagnostic('transport-failed'); clearTransport(); break; }
        finally { clearTimeout(timer); controller = null; }
      }
    } finally { sending = false; }
  };
  let pageEvents = 0;
  const field = (owner) => owner?.querySelector('.js-search-input, [data-navigation-filter]');
  const safePath = (value, source = false) => {
    try { const u = new URL(value, location.origin); return u.origin === location.origin
      && (/^\/(pages|collections|products)\/[a-z0-9][a-z0-9-]*\/?$/.test(u.pathname)
      || (source && ['/', '/search'].includes(u.pathname))) ? u.pathname : ''; } catch { return ''; }
  };
  const cancel = (owner, forget = false) => {
    const state = states.get(owner);
    if (state) { clearTimeout(state.timer); state.timer = null; state.current = null; state.revision++; }
    if (forget) { clearTimeout(state?.expiry); states.delete(owner); }
  };
  const publish = (name, payload, state) => {
    if (!enabled() || !consent() || !endpoint() || pageEvents >= 50 || state.events >= 20 || pending.length >= 20) return false;
    try {
      pending.push({ name, payload, at: Date.now() });
      void drain().catch(() => { transportFailed = true; clearTransport(); });
      pageEvents++; state.events++; return true;
    } catch { return false; }
  };
  const observe = (owner, context) => {
    diagnostic(enabled() ? 'observed' : 'capture-ineligible');
    if (!enabled() || !consent() || !endpoint() || pageEvents >= 50) return;
    for (const [element, state] of states) if (!element.isConnected || Date.now() - state.started >= 300000) cancel(element, true);
    if (!states.has(owner) && states.size >= 20) return;
    const input = field(owner);
    if (!owner?.isConnected || !input || typeof context?.query !== 'string') { diagnostic('invalid-owner'); return; }
    if (!context.query.trim()) { cancel(owner); return; }
    const valid = () => owner.isConnected && input.value === context.query && context.verified?.() === true;
    if (!valid() || !['predictive', 'navigation_page'].includes(context.surface)
      || !['collection', 'product', 'native'].includes(context.mode)
      || !['navigation_links', 'indexed_collections', 'shown_items'].includes(context.basis)
      || (context.surface === 'navigation_page' ? context.basis !== 'navigation_links' : context.basis === 'navigation_links')
      || !Number.isInteger(context.total) || context.total < 0 || context.total > 100000) { diagnostic('invalid-render'); cancel(owner); return; }
    let state = states.get(owner);
    if (!state || Date.now() - state.started >= 300000) {
      cancel(owner, true);
      const id = globalThis.crypto?.randomUUID?.();
      if (!id) { diagnostic('uuid-unavailable'); return; }
      state = { id, started: Date.now(), revision: 0, sequence: 0, events: 0, last: null, current: null };
      states.set(owner, state);
      state.expiry = setTimeout(() => cancel(owner, true), 300000);
    }
    clearTimeout(state.timer);
    const revision = state.revision;
    const key = JSON.stringify([context.query, context.mode, context.basis, context.total]);
    state.current = null;
    diagnostic('settling');
    state.timer = setTimeout(() => {
      state.timer = null;
      try {
      if (!valid() || revision !== state.revision || Date.now() - state.started >= 300000 || !consent()) return;
      if (state.last?.key === key) { state.current = { ...state.last, query: context.query, valid }; return; }
      const comparison = globalThis.RicochetSearchNormalizer?.normalizeSearchQuery?.(context.query) || context.query;
      const original = screen(context.query), normalized = screen(comparison);
      const payload = { schema_version: 1, exact_schema: 1, theme_id: String(globalThis.Shopify.theme.id), theme_role: 'main',
        surface: context.surface, placement: input.id === 'header-search' ? 'header' : 'page',
        source_path: safePath(location.href, true), interaction_id: state.id,
        attempt: state.sequence + 1, previous_attempt: state.sequence, result_state: 'known',
        mode: context.mode, result_count: context.total, result_basis: context.basis,
        text_status: original && normalized ? 'screened' : 'suppressed',
        ...(original && normalized ? { original_wording: original, comparison_wording: normalized } : {}),
        observed_recovery: state.last?.payload.result_count === 0 && context.total > 0 };
      if (state.sequence >= 20 || !payload.source_path || !publish('exact_search_attempt', payload, state)) return;
      state.sequence++;
      state.last = { key, payload };
      state.current = { ...state.last, query: context.query, valid };
      } catch { diagnostic('capture-exception'); state.current = null; } // Optional measurement cannot break shopping.
    }, 800);
  };
  document.addEventListener('input', (event) => {
    if (!enabled()) return;
    const owner = event.target.closest?.('predictive-search, [data-ricochet-navigation-page]');
    if (owner) cancel(owner);
  }, true);
  document.addEventListener('click', (event) => {
    if (!enabled() || !consent()) return;
    const link = event.target.closest?.('a[href]');
    const reset = event.target.closest?.('.js-search-reset, [data-navigation-clear]');
    const owner = (link || reset)?.closest('predictive-search, [data-ricochet-navigation-page]');
    if (!owner) return;
    if (reset) { cancel(owner, true); return; }
    if (!link.closest('.ricochet-navigation-grid, .js-search-results') || link.closest('[hidden]')) return;
    const state = states.get(owner), current = state?.current;
    const destination = safePath(link.href);
    if (!destination || !current || current.payload.result_count <= 0 || !current.valid() || Date.now() - state.started >= 300000) return;
    if (state.last.clicked === destination) return;
    if (publish('exact_search_selected', { ...current.payload, destination, selected_attempt: current.payload.attempt }, state)) state.last.clicked = destination;
  }, true);
  const clear = () => { clearTransport(); for (const owner of states.keys()) cancel(owner, true); };
  document.addEventListener('visitorConsentCollected', () => { if (!consent()) clear(); });
  window.addEventListener('pagehide', clear);
  globalThis.RicochetExactSearch = { observe: (...args) => { try { observe(...args); } catch { /* Browsing remains independent. */ } }, cancel, screen };
})();
